<p-dialog [header]="dialogHeader"
          [(visible)]="visible"
          (onHide)="close()"
          showEffect="fade"
          [modal]="true"
          [style]="{width: '800px'}">
    <form class="form-horizontal" role="form" *ngIf="parzelle">
        <fieldset class="container-fluid">

            @if (showLinkExistingOption) {
                <div class="row form-group parzelle-link-toggle">
                    <div class="col-xs-12">
                        <label class="parzelle-link-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="linkExisting"
                                   name="linkExisting">
                            Bestehende Parzelle zuordnen
                            <span class="text-muted">({{ parzellenWithoutCoordsOptions.length }} ohne Koordinaten)</span>
                        </label>
                    </div>
                </div>
            }

            @if (mode === 'create' && linkExisting) {
                <div class="row form-group">
                    <label for="existingParzelle" class="col-xs-5 control-label">Parzelle</label>
                    <div class="col-xs-7">
                        <p-select [style]="{'width':'100%'}"
                                  [options]="parzellenWithoutCoordsOptions"
                                  optionLabel="label"
                                  [(ngModel)]="selectedLinkOption"
                                  [filter]="true"
                                  filterBy="label"
                                  appendTo="body"
                                  placeholder="Parzelle auswählen"
                                  name="existingParzelle"
                                  id="existingParzelle">
                        </p-select>
                        @if (selectedLinkOption?.parzelle) {
                            <p class="help-block text-muted">
                                {{ selectedLinkOption.parzelle.laufmeter }} m Laufmeter
                                · {{ selectedLinkOption.parzelle.kurzname }}
                            </p>
                        }
                    </div>
                </div>
            }

            @if (mode === 'create' && !linkExisting) {
                <div class="row form-group">
                    <label for="sector" class="col-xs-5 control-label">Sektor</label>
                    <div class="col-xs-7">
                        <p-select [style]="{'width':'250px'}"
                                  [options]="allSektoren"
                                  [(ngModel)]="selectedSektor"
                                  (onChange)="onSektorChange()"
                                  placeholder="Bitte Sektor auswählen"
                                  name="sektor"
                                  id="sector">
                        </p-select>
                        @if (allowSektorCreate) {
                            <button type="button" class="btn btn-default btn-sm ms-2" (click)="showCreateSektorDialog()">
                                <i class="fa fa-plus"></i> Neuer Sektor
                            </button>
                        }
                    </div>
                </div>
            }

            @if (mode === 'edit' || (mode === 'create' && !linkExisting)) {
                <div class="row form-group">
                    <label for="name" class="col-xs-5 control-label">Name*</label>
                    <div class="col-xs-7">
                        <input id="name" type="text" class="form-control" [(ngModel)]="parzelle.name" name="name" required minlength="2">
                    </div>
                </div>

                <div class="row form-group">
                    <label for="kurzname" class="col-xs-5 control-label">Kurzname*</label>
                    <div class="col-xs-7">
                        <input id="kurzname" type="text" class="form-control" [(ngModel)]="parzelle.kurzname" name="kurzname" required minlength="2">
                    </div>
                </div>

                <div class="row form-group">
                    <label for="laufmeter" class="col-xs-5 control-label">Laufmeter* <small>(m)</small></label>
                    <div class="col-xs-7">
                        <input id="laufmeter" type="number" class="form-control" [(ngModel)]="parzelle.laufmeter" name="laufmeter" min="0.5" step="0.1" required>
                    </div>
                </div>

                <div class="row form-group">
                    <label for="tiefe" class="col-xs-5 control-label">Tiefe <small>(m)</small></label>
                    <div class="col-xs-7">
                        <input id="tiefe" type="number" class="form-control" [(ngModel)]="parzelle.tiefe" name="tiefe" min="0">
                    </div>
                </div>

                <div class="row form-group">
                    <label for="abstandBetween" class="col-xs-5 control-label">Abstand zwischen Standplätzen <small>(m)</small></label>
                    <div class="col-xs-7">
                        <input id="abstandBetween" type="number" class="form-control" [(ngModel)]="parzelle.abstandBetween" name="abstandBetween" min="0">
                    </div>
                </div>

                <div class="row form-group">
                    <label for="info" class="col-xs-5 control-label">Infos</label>
                    <div class="col-xs-7">
                        <textarea id="info" name="info" class="form-control" [(ngModel)]="parzelle.info"></textarea>
                    </div>
                </div>
            }

            <div class="row form-group">
                <div class="col-md-12">
                    @if (mode === 'edit') {
                        <button type="button" class="btn btn-danger" (click)="deleteParzelle()">Löschen</button>
                    }
                    <div class="pull-right">
                        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!isValid()">{{ saveButtonLabel }}</button>
                    </div>
                </div>
            </div>

        </fieldset>
    </form>
</p-dialog>

@if (allowSektorCreate) {
    <p-dialog header="Sektor erstellen"
              [(visible)]="displayCreateSektorDialog"
              showEffect="fade"
              [modal]="true"
              [style]="{width: '800px'}">
        <form class="form-horizontal" role="form" *ngIf="displayCreateSektorDialog">
            <fieldset class="container-fluid">
                <div class="form-group row">
                    <label for="sektorName" class="col-xs-5 control-label">Name*</label>
                    <div class="col-xs-7">
                        <input id="sektorName" type="text" placeholder="Beschreibung" class="form-control"
                               [(ngModel)]="sektorToCreate.name" name="sektorName"
                               (keyup)="updateSektorShortname($any($event.target).value)">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="sektorShortname" class="col-xs-5 control-label">Kurzname*</label>
                    <div class="col-xs-7">
                        <input id="sektorShortname" type="text" placeholder="Kurzname" class="form-control"
                               [(ngModel)]="sektorToCreate.shortname" name="sektorShortname">
                    </div>
                </div>

                <div class="form-group row">
                    <label for="numbering" class="col-xs-5 control-label">Nummerierung</label>
                    <div class="col-xs-7">
                        <p-selectButton id="numbering" [options]="numberingTypes"
                                        [(ngModel)]="selectedNumberingType" name="numbering"></p-selectButton>
                        @if (sektorToCreate?.shortname) {
                            <div>
                                <p style="margin-top: 1.5em; font-weight: bold;">Beispiel Nummerierung der Standplätze:</p>
                                <ul>
                                    @for (item of numberingExamples[selectedNumberingType]; track item) {
                                        <li>{{ sektorToCreate.shortname }}-S{{ item | number:'2.0-0' }}</li>
                                    }
                                    <li>...</li>
                                </ul>
                            </div>
                        }
                    </div>
                </div>
            </fieldset>
        </form>
        <div class="pull-right">
            <button type="button" class="btn btn-primary" (click)="createSektor()" [disabled]="!canCreateSektor()">Erstellen</button>
        </div>
    </p-dialog>
}
